import type { StoryblokBlock, BlockTransformContext } from '~/lib/storyblok'
import { transformImage } from '~/lib/storyblok'
import type { GalleryGridBlock } from './types'

export async function transformGalleryGridBlock(
  block: StoryblokBlock,
  { props, options }: BlockTransformContext,
): Promise<GalleryGridBlock> {
  const images = block.images.map(transformImage)

  return {
    ...props,
    images,
    options,
  }
}
